import React from 'react';
import { useNavigate } from 'react-router-dom';

const blogs = [
  {
    id: 'vpn-censorship',
    date: 'MAR 10, 2025',
    category: 'PRIVACY DEEP DIVES',
    title: 'What kinds of censorship can aSSL bypass?',
    summary: "We take a detailed look at how governments censor online services like TikTok and howSSLs...",
    content: `We take a detailed look at how governments censor online services like TikTok and howSSLs can help bypass these restrictions.\n\nIn this article, we explore the technical and legal aspects of internet censorship, the role ofSSLs, and real-world case studies.\n\nKey points:\n- HowSSLs work to bypass censorship\n- Limitations and risks\n- Countries with the strictest controls`,
    author: 'Jane Doe',
    image: '/public/vpn-sample.png',
  },
  {
    id: 'google-fingerprinting',
    date: 'MAR 4, 2025',
    category: 'PRIVACY DEEP DIVES',
    title: 'Google about-faces to allow device fingerprinting',
    summary: "In a spectacular about-face, Google has given the go-ahead to use unsafe and unfair ad tech tracki...",
    content: `In a spectacular about-face, Google has given the go-ahead to use unsafe and unfair ad tech tracking.\n\nWe break down what this means for user privacy, how device fingerprinting works, and what you can do to protect yourself.\n\nKey points:\n- What is device fingerprinting?\n- Why is Google allowing it?\n- How to protect your privacy`,
    author: 'John Smith',
    image: '/public/google-sample.png',
  },
  {
    id: 'wetrackssl-censorship',
    date: 'FEB 6, 2025',
    category: 'PRIVACY DEEP DIVES',
    title: 'Behind the scenes ofwetracksslSSL’s fight against censorship',
    summary: "In 2024,wetracksslSSL provided freeSSL access leading up to elections in countries with a history...",
    content: `In 2024,wetracksslSSL provided freeSSL access leading up to elections in countries with a history of censorship.\n\nThis blog post details the technical and logistical challenges faced, and the impact on users.\n\nKey points:\n- HowwetracksslSSL enabled access\n- The impact on election integrity\n- Lessons learned`,
    author: 'Alex Lee',
    image: '/public/2024-sample.png',
  },
];

const Blog: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold mb-12 text-center">Blog</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {blogs.map((blog, idx) => (
          <button
            key={blog.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col text-left cursor-pointer focus:outline-none hover:shadow-xl transition-shadow"
            onClick={() => navigate(`/blog/${blog.id}`)}
            type="button"
          >
            <div className="h-48 bg-gradient-to-br from-purple-100 to-purple-50 flex items-center justify-center">
              <div className="w-32 h-32 bg-white rounded-xl flex items-center justify-center">
                <span className="text-5xl text-purple-400 font-bold">{idx === 0 ? 'VPN' : idx === 1 ? <span className='text-4xl'>G</span> : '2024'}</span>
              </div>
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <div className="text-xs text-gray-400 mb-2 uppercase tracking-wide">
                {blog.date} · {blog.category}
              </div>
              <h2 className="text-lg font-semibold text-purple-800 mb-2 leading-snug">{blog.title}</h2>
              <p className="text-gray-600 text-base flex-1">{blog.summary}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Blog;
